import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { AnimatePresence } from 'framer-motion';

import { selectMessages } from '../../model/slice';

import { PushMessage } from './Message';

import cls from '../assets/styles.module.pcss';

export function PushContainer() {
  const messages = useSelector(selectMessages);

  return createPortal(
    <div className={cls.PushContainer}>
      <AnimatePresence>
        {Object.entries(messages).map(([id, message]) => (
          <PushMessage message={message} id={id} key={id} />
        ))}
      </AnimatePresence>
    </div>,
    document.body
  );
}
